<template>
  <div class="error-page">
    <div class="error-card">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#d93025" stroke-width="2"></circle>
          <line x1="15" y1="9" x2="9" y2="15" stroke="#d93025" stroke-width="2" stroke-linecap="round"></line>
          <line x1="9" y1="9" x2="15" y2="15" stroke="#d93025" stroke-width="2" stroke-linecap="round"></line>
        </svg>
      </div>

      <h1>無法存取文件</h1>
      <p>很抱歉，您目前無法存取此文件。</p>

      <div class="notice">
        <p>可能的原因：</p>
        <ul>
          <li>文件連結已失效或不存在</li>
          <li>文件已完成簽署</li>
          <li>文件暫時無法簽署</li>
        </ul>
        <p>如果您收到簽署邀請，請使用邀請郵件中的完整鏈接進行訪問。</p>
      </div>

      <div class="contact-info">
        <p>如有任何問題，請聯繫客戶服務：</p>
        <p class="service-phone">客服專線：{{ companyPhone }}</p>
        <p class="service-hours">{{ serviceHours }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const companyPhone = process.env.VUE_APP_COMPANY_PHONE;
    const serviceHours = process.env.VUE_APP_COMPANY_SERVICE_HOURS || '週一至週五 9:00-18:00';

    return {
      companyPhone,
      serviceHours
    };
  }
};
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  font-family: 'Noto Sans TC', sans-serif;
  padding: 16px;
  min-height: 80vh;
}

.error-card {
  max-width: 550px;
  width: 100%;
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.error-icon {
  color: #d93025;
  margin: 0 auto 24px;
  display: flex;
  justify-content: center;
}

h1 {
  color: #202124;
  margin-bottom: 16px;
  font-size: 28px;
  font-weight: 600;
}

p {
  color: #5f6368;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
}

.notice {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fff8e1;
  border-radius: 8px;
  text-align: left;
}

.notice p {
  margin: 0 0 10px 0;
  color: #5d4037;
}

.notice ul {
  margin: 0 0 10px 0;
  padding-left: 20px;
  color: #5d4037;
}

.notice li {
  margin-bottom: 6px;
  line-height: 1.4;
}

.notice p:last-child {
  margin-bottom: 0;
}

.contact-info {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e8eaed;
  font-size: 14px;
  color: #5f6368;
}

.service-phone {
  margin: 8px 0;
  font-weight: 500;
  color: #202124;
}

.service-hours {
  font-size: 13px;
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .error-card {
    padding: 24px 16px;
  }

  h1 {
    font-size: 24px;
  }

  .notice ul {
    padding-left: 16px;
  }
}
</style>